module.exports = __webpack_public_path__ + "img/54600.31dee7be.jpg";